module.exports = __webpack_public_path__ + "media/images/restaurant/savor_logo_en-bd07df382bece57eaf557504e28356c3.png";